/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */
import { v4 as uuid } from "uuid";
import { reducerLogger } from "../../../utility/reducerLogger";
export const dashboardUrlConfigActions = {
	DASHBOARD_URLS_LIST_GET: "DASHBOARD_URLS_LIST_GET",
	DASHBOARD_URLS_LIST_GET_SUCCESS: "DASHBOARD_URLS_LIST_GET_SUCCESS",
	DASHBOARD_URLS_LIST_GET_ERROR: "DASHBOARD_URLS_LIST_GET_ERROR",

	DASHBOARD_URLS_LIST_CLEAR_CHANGES: "DASHBOARD_URLS_LIST_CLEAR_CHANGES",
	DASHBOARD_URLS_LIST_ADD_NEW: "DASHBOARD_URLS_LIST_ADD_NEW",
	DASHBOARD_URLS_LIST_REMOVE: "DASHBOARD_URLS_LIST_REMOVE",
	DASHBOARD_URLS_LIST_MODIFY: "DASHBOARD_URLS_LIST_MODIFY",
	DASHBOARD_URLS_LIST_REORDER: "DASHBOARD_URLS_LIST_REORDER",

	DASHBOARD_URLS_LIST_UPDATE: "DASHBOARD_URLS_LIST_UPDATE",
	DASHBOARD_URLS_LIST_UPDATE_SUCCESS: "DASHBOARD_URLS_LIST_UPDATE_SUCCESS",
	DASHBOARD_URLS_LIST_UPDATE_ERROR: "DASHBOARD_URLS_LIST_UPDATE_ERROR",
};

export const newDashboardUrlObj = {
	reportId: "",
	reportName: "",
	reportUrl: "",
	isHidden: false,
	sortOrder: 0,
};

export const dashboardConfigInitialState = {
	enableDashboards: true,
	opensearchDomain: "",
	dashboardUrls: [],
	dashboardUrlsBackup: [],
	loading: false,
	error: "",
	message: "",
};

const sortDashboardUrlOnName = (reports) => {
	return reports?.sort((prevSts, curSts) => (prevSts.sortOrder < curSts.sortOrder ? -1 : 1));
};

export const dashboardUrlConfigReducer = reducerLogger((state, action) => {
	let dashboardUrls;
	switch (action.type) {
		// Fetching already configured scheduled report from database.
		case dashboardUrlConfigActions.DASHBOARD_URLS_LIST_GET:
			return {
				...state,
				dashboardUrls: [],
				proxyEndpoint: "",
				loading: true,
				error: "",
				dashboardUrlsBackup: [],
				message: "",
			};
		case dashboardUrlConfigActions.DASHBOARD_URLS_LIST_GET_SUCCESS:
			let {
				REACT_APP_DASHBOARD_CONFIGS: Urls,
				ENABLE_OPENSEARCH_DASHBOARDS: enableDashboards,
				OPENSEARCH_DASHBOARD_DOMAIN: opensearchDomain,
				ADMINBACKEND_PROXY_DASHBOARD_URL: proxyEndpoint,
			} = action.payload;
			dashboardUrls = sortDashboardUrlOnName(Urls);
			return {
				...state,
				dashboardUrls,
				enableDashboards,
				proxyEndpoint,
				opensearchDomain,
				dashboardUrlsBackup: JSON.parse(JSON.stringify(dashboardUrls)),
				loading: false,
				error: "",
				message: "",
			};
		case dashboardUrlConfigActions.DASHBOARD_URLS_LIST_GET_ERROR:
			return {
				...state,
				enableDashboards: false,
				dashboardUrls: [],
				dashboardUrlsBackup: [],
				loading: false,
				error: action.error,
				message: "",
			};
		case dashboardUrlConfigActions.DASHBOARD_URLS_LIST_ADD_NEW:
			dashboardUrls = [{ ...newDashboardUrlObj, reportId: uuid() }, ...state.dashboardUrls];
			return { ...state, dashboardUrls };
		case dashboardUrlConfigActions.DASHBOARD_URLS_LIST_REMOVE:
			dashboardUrls = state.dashboardUrls.filter((url) => url.reportId !== action.payload);
			return { ...state, dashboardUrls };
		case dashboardUrlConfigActions.DASHBOARD_URLS_LIST_MODIFY:
			dashboardUrls = state.dashboardUrls.map((url) => {
				if (url.reportId === action.reportId) {
					url[action.payload.fieldName] = action.payload.fieldValue;
				}
				return url;
			});
			return { ...state, dashboardUrls };
		case dashboardUrlConfigActions.DASHBOARD_URLS_LIST_CLEAR_CHANGES:
			return { ...state, dashboardUrls: JSON.parse(JSON.stringify(state.dashboardUrlsBackup)), message: "" };
		case dashboardUrlConfigActions.DASHBOARD_URLS_LIST_UPDATE:
			return { ...state, loading: true, message: "", error: "" };
		case dashboardUrlConfigActions.DASHBOARD_URLS_LIST_UPDATE_SUCCESS:
			return {
				...state,
				dashboardUrlsBackup: JSON.parse(JSON.stringify(state.dashboardUrls)),
				loading: false,
				enableDashboards: true,
				message: "Successfully saved dashboard configurations.",
			};
		case dashboardUrlConfigActions.DASHBOARD_URLS_LIST_UPDATE_ERROR:
			return {
				...state,
				loading: false,
				error: "Failed to save dashboard configurations.",
			};
		case dashboardUrlConfigActions.DASHBOARD_URLS_LIST_REORDER:
			return { ...state, dashboardUrls: action.payload };
		default:
			return state;
	}
});
